import { render, staticRenderFns } from "./AnswerList.vue?vue&type=template&id=670b2685&scoped=true&"
import script from "./AnswerList.vue?vue&type=script&lang=ts&"
export * from "./AnswerList.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerList.vue?vue&type=style&index=0&id=670b2685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b2685",
  null
  
)

export default component.exports